import { gql } from '@src/lib/gql'

/** Publish a tool draft or a new body as the visible author. The screen says Send. */
export const SEND_TOOL_MESSAGE = gql`
  mutation SendToolMessage($input: SendToolMessageInput!) {
    sendToolMessage(input: $input) {
      comment {
        commentId
        createdByUserId
        storedFiles {
          storedFileId
        }
      }
    }
  }
`
